// extracted by mini-css-extract-plugin
export default {"container":"lr-z","heading":"mr-z","text":"nr-z","info":"or-z","link":"pr-z","fullMaxWidth":"qr-z"};